// extracted by css-extract-rspack-plugin
export default {"MPGridContainer":"MPGridContainer-MPmnYS","mpGridContainer":"MPGridContainer-MPmnYS"};